import defaultSections from "./defaultFrameworkSections.json";

/** Canonical App Identity links keyed by gate0_field (works across sections). */
export function buildGate0Registry(sections = defaultSections) {
  const byField = {};
  const byText = {};
  for (const sec of sections) {
    for (const it of sec.items || []) {
      if (!it.gate0_field) continue;
      const canonicalText = (it.text || "").trim();
      if (!byField[it.gate0_field]) {
        byField[it.gate0_field] = {
          canonicalTexts: [],
          extraction_key: it.extraction_key,
        };
      }
      const meta = byField[it.gate0_field];
      if (canonicalText && !meta.canonicalTexts.includes(canonicalText)) {
        meta.canonicalTexts.push(canonicalText);
      }
      if (canonicalText) byText[canonicalText] = it.gate0_field;
    }
  }
  return { byField, byText };
}

export const GATE0_REGISTRY = buildGate0Registry();

export function canonicalTextForGate0Field(gate0Field) {
  const texts = GATE0_REGISTRY.byField[gate0Field]?.canonicalTexts;
  return texts?.[0] || "";
}

export function gate0FieldForCanonicalText(text) {
  return GATE0_REGISTRY.byText[(text || "").trim()] || null;
}

export function isTextCanonicalForGate0Field(text, gate0Field) {
  const texts = GATE0_REGISTRY.byField[gate0Field]?.canonicalTexts;
  if (!texts?.length) return false;
  return texts.includes((text || "").trim());
}

/** Attach or keep gate0_field for App Identity links (any section).

 * Custom templates often rewrite question text but keep gate0_field.
 * Only drop the link when the field key is unknown — never solely because
 * wording differs from the default canonical label.
 */
export function reconcileItemGate0Fields(item) {
  const text = (item.text || "").trim();
  const next = { ...item };
  if (next.gate0_field) {
    if (!GATE0_REGISTRY.byField[next.gate0_field]) {
      delete next.gate0_field;
    }
  }
  if (!next.gate0_field && text) {
    const field = gate0FieldForCanonicalText(text);
    if (field) {
      const meta = GATE0_REGISTRY.byField[field];
      next.gate0_field = field;
      next.extraction_key = next.extraction_key || meta?.extraction_key;
    }
  }
  return next;
}
